/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Default_Role_HelpInputs */



/**
* | output |
* | --- |
* | "Used when a row has no role or one that isn't recognised." |
*
* @param {Team_Manager_Import_Default_Role_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_default_role_help = /** @type {((inputs?: Team_Manager_Import_Default_Role_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Default_Role_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisé lorsqu'une ligne n'a pas de rôle ou un rôle inconnu.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird verwendet, wenn eine Zeile keine oder eine unbekannte Rolle hat.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usato quando una riga non ha un ruolo o ne ha uno non riconosciuto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Используется, если в строке нет роли или она не распознана.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se usa cuando una fila no tiene rol o tiene uno desconocido.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当某行没有角色或角色无法识别时使用。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行に役割がない場合や認識できない場合に使用します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जब किसी पंक्ति में भूमिका न हो या पहचानी न जाए, तब इस्तेमाल होती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Usada quando uma linha não tem função ou tem uma desconhecida.")
	return /** @type {LocalizedString} */ ("Used when a row has no role or one that isn't recognised.")
});